export function parseTemplate(text, variables = {}) {
    return text.replace(/\{(.*?)\}/g, (_, key) => {
        return variables[key] ?? `{${key}}`;
    });
}